<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.analyticsDashboard') }}</h1>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="block">
            <div class="header">{{ $t('reports.emtByStates') }}</div>
            <div class="filters">
              <span>{{ $t('docflow.plan.term') }}:</span>
              <a @click="setPeriod('week')" :class="{active: aDashboard.period === 'week'}">{{ $t('tasks.periods.week')
                }}</a>
              <a @click="setPeriod('month')" :class="{active: aDashboard.period === 'month'}">{{
                $t('tasks.periods.month') }}</a>
              <a @click="setPeriod('year')" :class="{active: aDashboard.period === 'year'}">{{ $t('tasks.periods.year')
                }}</a>
            </div>
            <table class="report-table">
              <thead>
              <tr>
                <td></td>
                <td class="has-background-success"><span class="vt">{{ $t('workflow.states.new') }}</span></td>
                <td class="has-background-danger"><span class="vt">{{ $t('workflow.states.new') }} ({{ $t('reports.userStats.expired') }})</span>
                </td>
                <td class="has-background-success"><span class="vt">{{ $t('workflow.states.in_process') }}</span></td>
                <td class="has-background-danger"><span
                    class="vt">{{ $t('workflow.states.in_process') }} ({{ $t('reports.userStats.expired') }})</span>
                </td>
                <td class="has-background-success"><span
                    class="vt">{{ $t('workflow.states.done') }}</span></td>
                <td class="has-background-warning"><span class="vt">{{ $t('workflow.states.done') }} ({{ $t('reports.userStats.expired') }})</span>
                </td>
                <td class="has-background-success"><span
                    class="vt">{{ $t('workflow.states.closed') }}</span></td>
                <td class="has-background-warning"><span class="vt">{{ $t('workflow.states.closed') }} ({{ $t('reports.userStats.expired') }})</span>
                </td>
              </tr>
              </thead>
              <tbody>
              <template v-for="item in emtByStates">
                <tr>
                  <td>{{item.name}}</td>
                  <td class="has-background-success">
                    <a @click="tasksByStates('new', item.id, false)">{{item.tasks_new}}</a>
                  </td>
                  <td class="has-background-danger">
                    <a @click="tasksByStates('new', item.id, true)">{{item.tasks_new_expired}}</a>
                  </td>
                  <td class="has-background-success">
                    <a @click="tasksByStates('in_process', item.id, false)">{{item.tasks_in_process}}</a>
                  </td>
                  <td class="has-background-danger">
                    <a @click="tasksByStates('in_process', item.id, true)">{{item.tasks_in_process_expired}}</a>
                  </td>
                  <td class="has-background-success">
                    <a @click="tasksByStates('done', item.id, false)">{{item.tasks_done}}</a>
                  </td>
                  <td class="has-background-warning">
                    <a @click="tasksByStates('done', item.id, true)">{{item.tasks_done_expired}}</a>
                  </td>
                  <td class="has-background-success">
                    <a @click="tasksByStates('closed', item.id, false)">{{item.tasks_closed}}</a>
                  </td>
                  <td class="has-background-warning">
                    <a @click="tasksByStates('closed', item.id, true)">{{item.tasks_closed_expired}}</a>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="column is-6">
          <div class="block">
            <div class="header" style="margin-bottom: 36px;">{{ $t('reports.emtByExpiration') }}</div>
            <table class="report-table">
              <thead>
              <tr>
                <td></td>
                <td class="has-background-danger"><span
                    class="vt">{{ $t('tasks.ePeriods.expired') }}</span></td>
                <td class="has-background-danger"><span
                    class="vt">{{ $t('tasks.ePeriods.expiring') }}</span></td>
                <td class="has-background-warning"><span
                    class="vt">{{ $t('tasks.ePeriods.expires_in_5_days') }}</span></td>
                <td class="has-background-success"><span
                    class="vt">{{ $t('tasks.ePeriods.expires_in_14_days') }}</span></td>
                <td class="has-background-success"><span
                    class="vt">{{ $t('tasks.ePeriods.expires_after_14_days') }}</span></td>
              </tr>
              </thead>
              <tbody>
              <template v-for="item in emtByTermDate">
                <tr>
                  <td>{{item.name}}</td>
                  <td class="has-background-danger">
                    <a @click="taskByExpiration('expired', item.id)">{{item.tasks_expired}}</a>
                  </td>
                  <td class="has-background-danger">
                    <a @click="taskByExpiration('expiring', item.id)">{{item.tasks_expiring}}</a>
                  </td>
                  <td class="has-background-warning">
                    <a @click="taskByExpiration('expires_in_5_days', item.id)">{{item.tasks_expiring_1}}</a>
                  </td>
                  <td class="has-background-success">
                    <a @click="taskByExpiration('expires_in_14_days', item.id)">{{item.tasks_expiring_2}}</a>
                  </td>
                  <td class="has-background-success">
                    <a @click="taskByExpiration('expires_after_14_days', item.id)">{{item.tasks_expiring_3}}</a>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="column is-6">
          <div class="block">
            <div class="header">{{ $t('reports.activityAnalytics') }}</div>
            <div class="filters">
              <span>{{ $t('docflow.plan.term') }}:</span>
              <a @click="setPeriod('day', 'aPeriod')" :class="{active: aDashboard.aPeriod === 'day'}">{{
                $t('reports.daily') }}</a>
              <a @click="setPeriod('month', 'aPeriod')" :class="{active: aDashboard.aPeriod === 'month'}">{{
                $t('reports.monthly')
                }}</a>
            </div>
            <div ref="activityChartDaily" v-if="aDashboard.aPeriod === 'day'"></div>
            <div ref="activityChartMonthly" v-else></div>
          </div>
        </div>
        <div class="column is-6">
          <div class="block">
            <div class="header">{{ $t('reports.executiveAnalytics') }}</div>
            <div class="filters">
              <span>{{ $t('docflow.plan.term') }}:</span>
              <a @click="setPeriod('week', 'ePeriod')" :class="{active: aDashboard.ePeriod === 'week'}">{{
                $t('tasks.periods.week')
                }}</a>
              <a @click="setPeriod('month', 'ePeriod')" :class="{active: aDashboard.ePeriod === 'month'}">{{
                $t('tasks.periods.month') }}</a>
              <a @click="setPeriod('year', 'ePeriod')" :class="{active: aDashboard.ePeriod === 'year'}">{{
                $t('tasks.periods.year')
                }}</a>
            </div>
            <div class="columns">
              <div class="column is-6">
                <div ref="totalTasksByState"></div>
              </div>
              <div class="column is-6">
                <div ref="totalTasksByAD"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {initialState} from '@/store/modules/filters'
  import Highcharts from '@/highcharts'
  import {mapState} from 'vuex'
  import moment from 'moment'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        period: 'month',
        ePeriod: 'month',
        aPeriod: 'day'
      }
    },
    methods: {
      loadData() {
        this.$store.dispatch('Reports/emtByStates')
        this.$store.dispatch('Reports/emtByTermDate')
        Promise.all([
          this.$store.dispatch('Reports/totalTasksByState'),
          this.$store.dispatch('Reports/totalTasksByAD'),
          this.$store.dispatch('Reports/tasksByDays'),
          this.$store.dispatch('Reports/tasksByMonth'),
        ]).then(() => this.$nextTick(this.drawCharts()))
      },
      setPeriod(period, which = 'period') {
        let val = {...this.aDashboard}
        val[which] = period
        this.$store.commit('Reports/SET', {key: 'aDashboard', val})
        this.loadData()
      },
      tasksByStates(state, analytic_dimension, show_expired) {
        this.$store.commit('Filters/SET', ['taskFilters', {
          ...initialState.taskFilters,
          state,
          analytic_dimension,
          show_expired,
          period: this.period
        }])
        this.$router.push({name: 'tasks'})
      },
      taskByExpiration(expiration_period, analytic_dimension) {
        this.$store.commit('Filters/SET', ['taskFilters', {
          ...initialState.taskFilters,
          analytic_dimension,
          expiration_period,
          show_expired: true
        }])
        this.$router.push({name: 'tasks'})
      },
      drawCharts() {
        Highcharts.chart(this.$refs.totalTasksByState, {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: false,
          subtitle: false,
          series: [
            {
              name: this.$t('reports.byStates'),
              data: Object.keys(this.totalTasksByState).map(state => {
                let cState = state.substring(6)
                let expired = false
                if (cState.includes('_expired')) {
                  cState = cState.slice(0, -8)
                  expired = true
                }
                let name = `${this.$t(`workflow.states.${cState}`)} ${expired ? `(${this.$t('reports.userStats.expired')})` : ''}`
                return {name, y: this.totalTasksByState[state]}
              })
            },
          ],
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
        })
        Highcharts.chart(this.$refs.totalTasksByAD, {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: false,
          subtitle: false,
          series: [
            {
              name: this.$t('reports.byAD'),
              data: this.totalTasksByAD.map(item => ({...item, y: item.tasks_count}))
            },
          ],
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
        })
        /*Bar chart by days*/
        let array30 = new Array(30)
        array30 = [...array30].map(_ => 0)
        let activityChartData1 = {
          dates: [...array30].map((_, i) => `${i + 1}${moment().format('-MM-YY')}`),
          data: {
            'new': [...array30],
            'in_process': [...array30],
            'done': [...array30],
            'rejected': [...array30],
            'closed': [...array30]
          }
        }
        this.tasksByDays.map(item => {
          activityChartData1.data[item.state][parseInt(item.date.substring(8)) - 1] = item.tasks_count
        })
        if (this.aDashboard.aPeriod === 'day') {
          Highcharts.chart(this.$refs.activityChartDaily, {
            chart: {
              type: 'bar'
            },
            xAxis: {
              categories: activityChartData1.dates,
            },
            yAxis: {
              min: 0,
              title: false,
              tickInterval: 1
            },
            plotOptions: {
              series: {
                stacking: 'normal'
              }
            },
            title: false,
            subtitle: false,
            series: Object.keys(activityChartData1.data).map(item => ({
              name: this.$t(`workflow.states.${item}`),
              data: activityChartData1.data[item]
            })),
          })
        }
        /*Bar chart by month*/
        let arrayM = new Array(parseInt(moment().format('MM')))
        arrayM = [...arrayM].map(_ => 0)
        let activityChartData2 = {
          dates: [...arrayM].map((_, i) => moment(i + 1, 'MM').locale(this.account.locale).format('MMMM')),
          data: {
            'new': [...arrayM],
            'in_process': [...arrayM],
            'done': [...arrayM],
            'rejected': [...arrayM],
            'closed': [...arrayM]
          }
        }
        this.tasksByMonth.map(item => {
          activityChartData2.data[item.state][item.month_index - 1] = item.tasks_count
        })
        if (this.aDashboard.aPeriod === 'month') {
          Highcharts.chart(this.$refs.activityChartMonthly, {
            chart: {
              type: 'bar'
            },
            xAxis: {
              categories: activityChartData2.dates,
            },
            yAxis: {
              min: 0,
              title: false,
              tickInterval: 1
            },
            plotOptions: {
              series: {
                stacking: 'normal'
              }
            },
            title: false,
            subtitle: false,
            series: Object.keys(activityChartData2.data).map(item => ({
              name: this.$t(`workflow.states.${item}`),
              data: activityChartData2.data[item]
            })),
          })
        }
      },
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('Reports', [
        'emtByStates',
        'emtByTermDate',
        'totalTasksByState',
        'totalTasksByAD',
        'tasksByDays',
        'tasksByMonth',
        'aDashboard'
      ]),
      ...mapState('Account', ['account']),
      breadcrumbs() {
        return [
          {name: 'analyticsDashboard'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .vt {
    text-align: center;
    writing-mode: tb-rl !important;
    vertical-align: middle;
    transform: rotate(-180deg);
  }

  .block {
    .header {
      font-size: 17px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    .filters {
      margin-bottom: 10px;

      span {
        display: inline-block;
        margin-right: 10px;
        color: #8E8E8E;
      }

      a {
        margin-right: 10px;

        &.active {
          color: #3498DB;
        }
      }
    }

    .report-table {
      width: 100%;

      thead > tr > td:not(:first-child) {
        height: 106px;
        line-height: 120%;
      }

      tr > td:not(:first-child) {
        width: 40px;
        text-align: center;
      }

      td {
        padding: 4px 8px;
      }


      tr > td:not(.has-background-warning):not(:first-child) {
        color: #fff;

        a {
          color: #fff;
        }
      }

      tr > td.has-background-warning {
        color: #444;

        a {
          color: #444;
        }
      }

      a {
        text-decoration: underline;
      }
    }
  }

  .pie {
    position: relative;
    left: -7%;
  }
</style>
